import { JobTypes } from "@lib/enums";
import { Box, styled } from "@mui/material";

const IconContainer = styled(Box)(({ theme }) => ({
  width: "24px",
  height: "24px",
}));

const icons = {
  [JobTypes.AI]: "/img/floats/sola.svg",
};

export default function Icon({ type }) {
  return (
    <IconContainer>
      <img src={icons[type]} width="24" alt="Status icon" />
    </IconContainer>
  );
}
